import { render, staticRenderFns } from "./FolderModal.vue?vue&type=template&id=7dc8e01a&"
import script from "./FolderModal.vue?vue&type=script&lang=js&"
export * from "./FolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc8e01a')) {
      api.createRecord('7dc8e01a', component.options)
    } else {
      api.reload('7dc8e01a', component.options)
    }
    module.hot.accept("./FolderModal.vue?vue&type=template&id=7dc8e01a&", function () {
      api.rerender('7dc8e01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/FolderModal.vue"
export default component.exports